import {pageInfo, exportData} from './../api';
import {Message} from 'element-ui';

const loginLog = {
  namespaced: true,
  state: {
    total: 0,
    pageResp: null,
    exportDataObj: null
  },
  mutations: {
    PAGE_INFO(state, data) {
      state.total = data.total;
      state.pageResp = data.obj || [];
    },
    EXPORT_DATE(state, data) {
      state.exportDataObj = data;
    },
  },
  actions: {
    //查询事件
    async pageInfo({commit}, obj) {
      let resp = await pageInfo(obj);
      commit('PAGE_INFO', resp);
    },
    async exportData({commit}, obj) {
      let resp = await exportData(obj);
      commit('EXPORT_DATE', resp);
    }
  }
}
export default loginLog



// WEBPACK FOOTER //
// ./src/page/log/loginLog/store/loginLog.store.js